/**
 * Codes d'erreur de `sendContactRequest` (API `contact.service.ts`) et leur
 * libellé (#81). Un code inconnu retombe sur l'échec d'envoi générique.
 */
const CONTACT_ERROR_KEYS: Record<string, string> = {
  SUBJECT_REQUIRED: 'contact.error.subjectRequired',
  SUBJECT_TOO_LONG: 'contact.error.subjectTooLong',
  MESSAGE_REQUIRED: 'contact.error.messageRequired',
  MESSAGE_TOO_LONG: 'contact.error.messageTooLong',
  ATTACHMENT_TOO_LARGE: 'contact.attachment.tooLarge',
  ATTACHMENT_INVALID_TYPE: 'contact.attachment.invalidType',
  ThrottlerException: 'contact.error.tooMany',
}

export function contactErrorKey(error: unknown): string {
  const message = error instanceof Error ? error.message : ''
  const code = Object.keys(CONTACT_ERROR_KEYS).find(key => message.includes(key))
  return code ? CONTACT_ERROR_KEYS[code]! : 'contact.error.sendFailed'
}
